import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const metricDisplayNames = {
  Applications_Submitted_Citizen: "Schemes DS Citizen",
  HDs_trained: "HDs Trained",
  Screenings_Citizen: "Citizen Screening",
  Target_No_Yojana_Card: "Yojana Card BR",
  Target_No_DFL: "DFL BR",
  Screening_MSME: "MSME Screening",
  Benefit_Received_Citizen:"Schemes BR Citizen"
};

const ProjectOverall = () => {
  const pid = useSelector((state) => state.user.projectId);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pid) return;

    const fetchProjectData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          "https://api-usersreport-insights.haqdarshak.com/api/ar_project_summary",
          { params: { PID: pid } }
        );
        setData(response.data || []);
      } catch (err) {
        console.error("Error fetching project summary:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectData();
  }, [pid]);

  if (!pid) {
    return <div className="text-gray-600">No project selected.</div>;
  }

  if (loading) {
    return <div className="text-gray-700 font-medium">Loading project summary...</div>;
  }

  if (error) {
    return (
      <div className="text-red-600">
        Failed to load project summary: {error.message}
      </div>
    );
  }

  if (data.length === 0) {
    return <div className="text-gray-500">No data available for this project.</div>;
  }

  return (
    <div className="p-6 mt-6 mx-[2vw] bg-white shadow-lg rounded-2xl border border-gray-200">
      <h2 className="text-xl font-semibold mb-2 text-gray-800">
        Project Summary
      </h2>
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 rounded-lg">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="px-4 py-2 text-left font-semibold">Deliverables</th>
              <th className="px-4 py-2 text-center font-semibold">Total Target</th>
              <th className="px-4 py-2 text-center font-semibold">
                Achieved (Till Date)
              </th>
              <th className="px-4 py-2 text-center font-semibold">
                Total Achieved (%)
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr
                key={index}
                className={`${
                  index % 2 === 0 ? "bg-white" : "bg-gray-50"
                } hover:bg-gray-100 transition-all`}
              >
                <td className="px-4 py-2 font-medium text-gray-800">
                  {metricDisplayNames[item.metric] || item.metric_name}
                </td>
                <td className="px-4 py-2 text-center text-gray-700">
                  {Number(item.total_target).toLocaleString()}
                </td>
                <td className="px-4 py-2 text-center text-gray-700">
                  {Number(item.total_value).toLocaleString()}
                </td>
                <td
                  className={`px-4 py-2 text-center font-semibold ${
                    item.pct_achieved >= 100
                      ? "text-green-600"
                      : item.pct_achieved >= 75
                      ? "text-yellow-600"
                      : "text-red-600"
                  }`}
                >
                  {item.pct_achieved}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectOverall;
